export default "__VITE_ASSET__BL87PzNe__"